import React from "react"
import { navigate } from "gatsby"
import DfbIcon from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_icon"
import DfbParagraph from "@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph"
import { closedAreaContent } from "../../../../utils/closedArea/content"

const MBackLink = props => {
  const { path, label, testid } = props

  const goBack = e => {
    if (path) {
      navigate(path)
    } else {
      window.history.back()
    }
  }

  return (
    <div className="m-BackLink" data-testid={testid ?? null}>
      <div className="m-BackLink-wrapper">
        <div className="m-BackLink-container">
          <button
            className="m-BackLink-anchor"
            onClick={goBack}
            aria-label={closedAreaContent.backlink.defaultText}
          >
            <DfbIcon icon_type="arrow-left" add_class="m-BackLink-icon" />
            <DfbParagraph
              text={label ? label : closedAreaContent.backlink.defaultText}
              add_class="m-BackLink-label"
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default MBackLink
